import appConfig from "../../config.json";

const baseUrl =
    process.env.REACT_APP_REST_API || appConfig.config.REACT_APP_REST_API;

export function getProperImageUrl(imagePath) {
    return `${baseUrl}/files/${imagePath}`;
}

